import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useOnboardingStore } from '../../store/useOnboardingStore';
import logo from "../../assets/images/logo_2.png";
import { Link } from 'react-router-dom';
import Select, { StylesConfig } from 'react-select';

/* ═══════════════════════════════════════════════════
   INJECT STYLES
═══════════════════════════════════════════════════ */
const injectKF = () => {
  if (document.getElementById("ob2-kf")) return;
  const s = document.createElement("style");
  s.id = "ob2-kf";
  s.innerHTML = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

    @keyframes slideInBot {
      from { opacity:0; transform:translateY(-8px) scale(0.96); }
      to   { opacity:1; transform:translateY(0)    scale(1);    }
    }
    @keyframes botCursor { 0%,100%{opacity:1} 50%{opacity:0} }
    @keyframes speakBar  { 0%,100%{transform:scaleY(1)} 50%{transform:scaleY(1.9)} }
    @keyframes pulseDot  { 0%,100%{opacity:1} 50%{opacity:.35} }
    @keyframes botBobSvg { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-2.5px)} }
    @keyframes floatHeartL1 {
      0%  { transform:translate(0,0)         scale(1);    opacity:1; }
      100%{ transform:translate(-14px,-54px) scale(0.18); opacity:0; }
    }
    @keyframes floatHeartL2 {
      0%  { transform:translate(0,0)        scale(0.82); opacity:0.9; }
      100%{ transform:translate(-4px,-58px) scale(0.12); opacity:0; }
    }
    @keyframes floatHeartL3 {
      0%  { transform:translate(0,0)       scale(0.68); opacity:0.8; }
      100%{ transform:translate(9px,-50px) scale(0.22); opacity:0; }
    }
    @keyframes floatHeartR1 {
      0%  { transform:translate(0,0)        scale(1);    opacity:1; }
      100%{ transform:translate(14px,-54px) scale(0.18); opacity:0; }
    }
    @keyframes floatHeartR2 {
      0%  { transform:translate(0,0)       scale(0.82); opacity:0.9; }
      100%{ transform:translate(4px,-58px) scale(0.12); opacity:0; }
    }
    @keyframes floatHeartR3 {
      0%  { transform:translate(0,0)        scale(0.68); opacity:0.8; }
      100%{ transform:translate(-9px,-50px) scale(0.22); opacity:0; }
    }

    .ob2-bot-bob { animation: botBobSvg 3s ease-in-out infinite; }
    .ob2-hl1 { animation: floatHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
    .ob2-hl2 { animation: floatHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
    .ob2-hl3 { animation: floatHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
    .ob2-hr1 { animation: floatHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
    .ob2-hr2 { animation: floatHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
    .ob2-hr3 { animation: floatHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }

    .ob2-wrap { position:fixed; z-index:99999; animation:slideInBot .28s cubic-bezier(.34,1.2,.64,1) both; }
    .ob2-wrap::before { content:''; position:absolute; width:16px; height:9px; background:#c0001a; clip-path:polygon(50% 0%,100% 100%,0% 100%); }
    .ob2-wrap.below::before   { top:-9px;    left:24px; }
    .ob2-wrap.above::before   { bottom:-9px; left:24px; transform:rotate(180deg); }
    .ob2-wrap.toright::before { top:24px;    left:-9px; transform:rotate(-90deg); }
    .ob2-wrap.toleft::before  { top:24px;    right:-9px; transform:rotate(90deg); }

    .ob2-card { background:#fff; border-radius:14px; border:1px solid rgba(0,0,0,.07); overflow:hidden; box-shadow:0 4px 8px rgba(0,0,0,.06),0 18px 52px rgba(0,0,0,.18),0 2px 10px rgba(192,0,26,.1); }
    .ob2-hd { background:linear-gradient(135deg,#c0001a 0%,#8b0000 58%,#5c0000 100%); padding:12px 14px 10px; display:flex; align-items:center; gap:10px; position:relative; overflow:visible; }
    .ob2-hd::after { content:''; position:absolute; inset:0; pointer-events:none; background-image:linear-gradient(rgba(255,255,255,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.04) 1px,transparent 1px); background-size:16px 16px; }
    .ob2-av { position:relative; flex-shrink:0; z-index:1; overflow:visible; }
    .ob2-bars { display:flex; align-items:flex-end; gap:2px; position:absolute; bottom:-3px; right:-4px; background:rgba(0,0,0,.3); border-radius:4px; padding:2px 3px; z-index:2; }
    .ob2-b { width:2.5px; border-radius:2px; background:#fff; transform-origin:bottom; }
    .ob2-b:nth-child(1){ height:4px;  animation:speakBar .48s .00s ease-in-out infinite; }
    .ob2-b:nth-child(2){ height:9px;  animation:speakBar .48s .10s ease-in-out infinite; }
    .ob2-b:nth-child(3){ height:6px;  animation:speakBar .48s .20s ease-in-out infinite; }
    .ob2-b:nth-child(4){ height:3px;  animation:speakBar .48s .30s ease-in-out infinite; }
    .ob2-meta { flex:1; z-index:1; min-width:0; overflow:hidden; }
    .ob2-name { font-size:11.5px; font-weight:800; color:#fff; letter-spacing:.06em; font-family:'DM Mono','Fira Code',monospace; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .ob2-sub  { font-size:9.5px; color:rgba(255,255,255,.7); display:flex; align-items:center; gap:4px; margin-top:2px; }
    .ob2-dot  { width:5px; height:5px; border-radius:50%; background:#6effa0; box-shadow:0 0 4px rgba(100,255,150,.85); flex-shrink:0; animation:pulseDot 2s ease-in-out infinite; }
    .ob2-badge{ z-index:1; flex-shrink:0; background:rgba(255,255,255,.16); border:1px solid rgba(255,255,255,.3); border-radius:20px; padding:2px 8px; font-size:10px; font-weight:700; color:#fff; white-space:nowrap; }
    .ob2-tag     { background:linear-gradient(90deg,#fff5f5,#fff); border-bottom:1px solid rgba(192,0,26,.1); padding:5px 14px; display:flex; align-items:center; gap:6px; }
    .ob2-tag-dot { width:5px; height:5px; border-radius:50%; background:#c0001a; flex-shrink:0; }
    .ob2-tag-txt { font-size:9.5px; font-weight:800; color:#c0001a; letter-spacing:.08em; }
    .ob2-body { padding:10px 14px 8px; }
    .ob2-msg  { font-size:13px; line-height:1.62; color:#1a1a1a; word-break:break-word; margin:0; }
    .ob2-msg strong { color:#c0001a; font-weight:800; }
    .ob2-cur  { display:inline-block; width:2px; height:13px; background:#c0001a; border-radius:2px; margin-left:2px; vertical-align:middle; animation:botCursor .65s ease-in-out infinite; }
    .ob2-ft   { padding:8px 14px 11px; display:flex; align-items:center; justify-content:space-between; gap:8px; border-top:1px solid rgba(0,0,0,.05); background:#fafafa; }
    .ob2-dots { display:flex; gap:4px; align-items:center; }
    .ob2-d    { width:6px; height:6px; border-radius:50%; background:#e0e0e0; transition:all .3s; }
    .ob2-d.on { width:18px; border-radius:999px; background:linear-gradient(90deg,#c0001a,#8b0000); }
    .ob2-skip { background:none; border:none; cursor:pointer; font-size:11px; color:#c0c0c0; padding:4px 6px; border-radius:6px; transition:all .18s; white-space:nowrap; }
    .ob2-skip:hover { background:#f0f0f0; color:#888; }
    .ob2-next { background:linear-gradient(135deg,#c0001a,#8b0000); color:#fff; border:none; border-radius:8px; padding:7px 16px; font-size:12px; font-weight:800; cursor:pointer; letter-spacing:.03em; box-shadow:0 3px 12px rgba(192,0,26,.32); transition:all .18s; white-space:nowrap; }
    .ob2-next:hover  { transform:translateY(-1px); box-shadow:0 5px 16px rgba(192,0,26,.46); }
    .ob2-next:active { transform:scale(.97); }

    /* ── Section background — Step4 se same ── */
    .ob2-section { background:#f8f5f0 !important; min-height:100vh !important; }

    /* ── Progress bars ── */
    .ob2-prog-wrap { display:flex !important; gap:5px !important; margin-top:10px !important; }
    .ob2-prog-bar  { height:4px !important; border-radius:999px !important; flex:1 !important; background:#e2e8f0 !important; }
    .ob2-prog-bar.done   { background:linear-gradient(90deg,#c0001a,#8b0000) !important; }
    .ob2-prog-bar.active { background:linear-gradient(90deg,#e0001f,#c0001a) !important; }

    /* ── Mobile: compact, overlap-safe bot popup ── */
    @media (max-width: 767px) {
      .ob2-wrap    { max-width:calc(100vw - 24px); }
      .ob2-card    { border-radius:10px; }
      .ob2-hd      { padding:7px 8px 6px; gap:6px; }
      .ob2-av svg  { width:34px !important; height:34px !important; }
      .ob2-bars    { padding:1px 2px; bottom:-2px; right:-2px; }
      .ob2-b       { width:1.5px; }
      .ob2-name    { font-size:9px; letter-spacing:.03em; }
      .ob2-sub     { font-size:7.5px; }
      .ob2-dot     { width:4px; height:4px; }
      .ob2-badge   { font-size:8px; padding:1px 5px; }
      .ob2-tag     { padding:3px 8px; }
      .ob2-tag-dot { width:4px; height:4px; }
      .ob2-tag-txt { font-size:7.5px; }
      .ob2-body    { padding:6px 8px 5px; }
      .ob2-msg     { font-size:11px; line-height:1.4; }
      .ob2-ft      { padding:5px 8px 7px; }
      .ob2-skip    { font-size:9px; padding:2px 4px; }
      .ob2-next    { font-size:10px; padding:5px 10px; }
      .ob2-d       { width:4px; height:4px; }
      .ob2-d.on    { width:12px; }
    }
  `;
  document.head.appendChild(s);
};

/* ═══════════════════════════════════════════════════
   BOT FACE SVG — Step4 se exact same
═══════════════════════════════════════════════════ */
const BotFaceSVG: React.FC = () => (
  <svg width="64" height="64" viewBox="0 0 72 72" fill="none" style={{ overflow: "visible" }}>
    <defs>
      <style>{`
        .ob2-bot-bob { animation: botBobSvg 3s ease-in-out infinite; }
        .ob2-hl1 { animation: floatHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
        .ob2-hl2 { animation: floatHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
        .ob2-hl3 { animation: floatHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
        .ob2-hr1 { animation: floatHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
        .ob2-hr2 { animation: floatHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
        .ob2-hr3 { animation: floatHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }
      `}</style>
    </defs>
    <g className="ob2-bot-bob">
      <line x1="36" y1="10" x2="36" y2="3" stroke="rgba(255,255,255,0.82)" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="36" cy="2" r="3.2" fill="rgba(255,255,255,0.9)" />
      <rect x="7" y="10" width="58" height="46" rx="15" fill="rgba(255,255,255,0.97)" />
      <circle cx="7"  cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2" />
      <circle cx="65" cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2" />
      <rect x="11" y="17" width="24" height="20" rx="9" fill="#c0001a" />
      <rect x="37" y="17" width="24" height="20" rx="9" fill="#8b0000" />
      <ellipse cx="23" cy="27" rx="9" ry="8" fill="white" />
      <ellipse cx="49" cy="27" rx="9" ry="8" fill="white" />
      <g className="ob2-hl1"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff3d6b" /></g>
      <g className="ob2-hl2"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#c0001a" opacity="0.88" /></g>
      <g className="ob2-hl3"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff7099" /></g>
      <g className="ob2-hr1"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff3d6b" /></g>
      <g className="ob2-hr2"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#c0001a" opacity="0.88" /></g>
      <g className="ob2-hr3"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff7099" /></g>
      <path d="M16,46 Q36,60 56,46" stroke="#c0001a" strokeWidth="2.8" strokeLinecap="round" fill="none" />
      <ellipse cx="12" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)" />
      <ellipse cx="60" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)" />
      <line x1="7"  y1="28" x2="2"  y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="7"  y1="36" x2="2"  y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="65" y1="28" x2="70" y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="65" y1="36" x2="70" y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
    </g>
  </svg>
);

/* ═══════════════════════════════════════════════════
   TYPES + BOT STEPS
═══════════════════════════════════════════════════ */
type BotSide = "below" | "above" | "toright" | "toleft";
interface StepData { tag: string; plain: string; html: React.ReactNode; sideLg: BotSide; }

// Shared sizing constants — used by BotPopup for its own box AND by Step2
// to size the spacer that pushes page content down so the popup never
// overlaps the next form field/MCQ. Kept small so the bot stays compact
// and hugs the exact anchor field on mobile.
const GAP = 8;
const POPUP_W_MOBILE = 230, POPUP_W_DESKTOP = 310;
const POPUP_H_MOBILE = 130, POPUP_H_DESKTOP = 240;

// sideLg is always "below" now — the popup is forced to appear under its anchor
// on every screen size, so this field is kept only to satisfy the StepData type.
const BOT_STEPS: StepData[] = [
  { tag:"STEP 1 OF 6 — LOOKING FOR",   plain:"Tell us — who are you looking for? Start from here!",       html:<>💘 Tell us — <strong>who are you looking for?</strong> Start from here!</>,       sideLg:"below" },
  { tag:"STEP 2 OF 6 — RELATIONSHIP",  plain:"What kind of relationship do you want? Serious or casual?", html:<>💑 <strong>What kind of relationship</strong> do you want? Serious or casual?</>, sideLg:"below" },
  { tag:"STEP 3 OF 6 — DISTANCE",      plain:"How far away do you want to find matches?",                  html:<>📍 <strong>How far away</strong> do you want to find matches?</>,                 sideLg:"below" },
  { tag:"STEP 4 OF 6 — AGE RANGE",     plain:"Ideal age range — fill both From and To!",                  html:<>🎯 <strong>Ideal age range</strong> — fill both From and To!</>,                  sideLg:"below" },
  { tag:"STEP 5 OF 6 — LAST QUESTION", plain:"Last question! Select this too and get ready!",              html:<>✨ <strong>Last question!</strong> Select this and get ready!</>,                  sideLg:"below" },
  { tag:"STEP 6 OF 6 — ALL SET!",      plain:"All set! Tap Continue to move to the next step!",            html:<>🚀 All set! <strong>Tap Continue</strong> to move to the next step!</>,            sideLg:"below" },
];

const TOTAL = BOT_STEPS.length;

/* ═══════════════════════════════════════════════════
   BOT POPUP
═══════════════════════════════════════════════════ */
interface PopupProps {
  anchorRef: React.RefObject<HTMLDivElement | null>;
  step:      number;
  data:      StepData;
  onSkip:    () => void;
  onNext:    () => void;
  nextLabel: string;
}

const BotPopup: React.FC<PopupProps> = ({ anchorRef, step, data, onSkip, onNext, nextLabel }) => {
  // Mobile gets a smaller card so it never overlaps form fields or screen edges.
  const isMobileScreen = typeof window !== "undefined" && window.innerWidth < 768;
  const PW = isMobileScreen ? POPUP_W_MOBILE : POPUP_W_DESKTOP;
  const POPUP_H = isMobileScreen ? POPUP_H_MOBILE : POPUP_H_DESKTOP;

  const [pos,        setPos]        = useState<{ top:number; left:number; width:number } | null>(null);
  const [activeSide, setActiveSide] = useState<BotSide>("below");
  const [displayed,  setDisplayed]  = useState("");
  const [done,       setDone]       = useState(false);
  const [status,     setStatus]     = useState("typing...");
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const retryRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const calcPos = useCallback((): boolean => {
    if (!anchorRef.current) return false;
    const r = anchorRef.current.getBoundingClientRect();
    const vw = window.innerWidth, vh = window.innerHeight;
    if (r.width === 0 && r.height === 0) return false;

    // Popup always appears BELOW the anchor — never above, never to the side.
    // It hugs the anchor's own left edge (not screen-center) so it visually
    // sits directly under the field it refers to.
    if (vw < 768) {
      const popW = Math.min(vw - 16, PW);
      const top = Math.max(8, Math.min(r.bottom + GAP, vh - POPUP_H - 8));
      let left = r.left;
      left = Math.max(8, Math.min(left, vw - popW - 8));
      setActiveSide("below");
      setPos({ top, left, width: popW });
      return true;
    }

    let left = r.left;
    if (left + PW > vw - 8) left = vw - PW - 8;
    left = Math.max(12, Math.min(left, vw - PW - 12));

    const top = Math.max(8, Math.min(r.bottom + GAP, vh - POPUP_H - 8));

    setActiveSide("below");
    setPos({ top, left, width: PW });
    return true;
  }, [anchorRef]);

  useEffect(() => {
    let attempts = 0; const MAX = 50;
    if (retryRef.current) clearTimeout(retryRef.current);
    setPos(null);
    const tryCalc = () => { const ok = calcPos(); if (!ok && attempts < MAX) { attempts++; retryRef.current = setTimeout(tryCalc, 80); } };
    tryCalc();
    window.addEventListener("resize", calcPos);
    window.addEventListener("scroll", calcPos, true);
    return () => {
      if (retryRef.current) clearTimeout(retryRef.current);
      window.removeEventListener("resize", calcPos);
      window.removeEventListener("scroll", calcPos, true);
    };
  }, [calcPos, step]);

  useEffect(() => {
    setDisplayed(""); setDone(false); setStatus("typing...");
    let i = 0;
    const tick = () => {
      if (i <= data.plain.length) { setDisplayed(data.plain.slice(0, i)); i++; timerRef.current = setTimeout(tick, 21); }
      else { setDone(true); setStatus("Online — here to guide you!"); }
    };
    tick();
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, [data.plain, step]);

  if (!pos) return null;
  const isSide = activeSide === "toright" || activeSide === "toleft";

  return (
    <div className={`ob2-wrap ${activeSide}`} style={{ top: pos.top, left: pos.left, width: pos.width, transform: isSide ? "translateY(-50%)" : "none" }}>
      <div className="ob2-card" style={{ width: "100%" }}>
        <div className="ob2-hd">
          <div className="ob2-av">
            <BotFaceSVG />
            <div className="ob2-bars"><div className="ob2-b"/><div className="ob2-b"/><div className="ob2-b"/><div className="ob2-b"/></div>
          </div>
          <div className="ob2-meta">
            <div className="ob2-name">SLAMMMM GUIDE</div>
            <div className="ob2-sub"><div className="ob2-dot"/><span>{status}</span></div>
          </div>
          <div className="ob2-badge">{step}/{TOTAL}</div>
        </div>
        <div className="ob2-tag"><div className="ob2-tag-dot"/><div className="ob2-tag-txt">{data.tag}</div></div>
        <div className="ob2-body">
          {done
            ? <p className="ob2-msg">{data.html}</p>
            : <p className="ob2-msg">{displayed}<span className="ob2-cur"/></p>
          }
        </div>
        <div className="ob2-ft">
          <div className="ob2-dots">
            {Array.from({ length: TOTAL }).map((_, i) => (
              <div key={i} className={`ob2-d${i + 1 === step ? " on" : ""}`}/>
            ))}
          </div>
          <div style={{ display:"flex", gap:8, alignItems:"center" }}>
            <button className="ob2-skip" onClick={onSkip}>Skip guide</button>
            <button className="ob2-next" onClick={onNext}
              onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.transform = "translateY(-1px)"; }}
              onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.transform = "none"; }}
            >{nextLabel}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════════════
   STEP 2 — MAIN COMPONENT
═══════════════════════════════════════════════════ */
type SelectOption = { value: number; label: string };

const Step2 = () => {
  const {
    questions, fetchQuestions, selectOption,
    inputs, handleInputChange,
    currentStep, errors,
    validate2, nextStep, prevStep,
  } = useOnboardingStore();

  const stepQuestions = (questions || []).filter((q: any) => q.step === currentStep);
  const [buttonHighlight, setButtonHighlight] = useState(false);

  const ageOptions: SelectOption[] = Array.from({ length: 82 }, (_, i) => ({
    value: i + 18,
    label: (i + 18).toString(),
  }));

  useEffect(() => { fetchQuestions(); }, [fetchQuestions]);

  const selectedCount  = stepQuestions.filter((q: any) => q.selected).length;
  const [currentIndex, setCurrentIndex] = useState(selectedCount > 0 ? selectedCount + 1 : 0);

  /* ── Bot state ── */
  const [guideStep, setGuideStep] = useState<number | null>(null);
  /* ── auto-advance lock: prevent double jump ── */
  const autoAdvancedRef = useRef<Set<number>>(new Set());

  /* Track viewport width so the spacer (which pushes content down while the
     bot is showing) matches the popup's actual mobile/desktop size. */
  const [viewportW, setViewportW] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);
  useEffect(() => {
    const onResize = () => setViewportW(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const spacerH = (viewportW < 768 ? POPUP_H_MOBILE : POPUP_H_DESKTOP) + GAP + 8;

  /* Renders an invisible spacer right after a bot-guide anchor. This pushes
     the next question/field down in normal document flow so the fixed-position
     bot popup (which floats below the anchor) never overlaps/hides its MCQ. */
  const BotSpacer = ({ n }: { n: number }) => (
    <div style={{ height: guideStep === n ? spacerH : 0, transition: "height .2s ease" }} />
  );

  const refQ1       = useRef<HTMLDivElement>(null);
  const refQ2       = useRef<HTMLDivElement>(null);
  const refQ3       = useRef<HTMLDivElement>(null);
  const refAgeRange = useRef<HTMLDivElement>(null);
  const refQ4       = useRef<HTMLDivElement>(null);
  const refContinue = useRef<HTMLDivElement>(null);
  const botRefs     = [refQ1, refQ2, refQ3, refAgeRange, refQ4, refContinue];

  useEffect(() => {
    injectKF();
    const seen = localStorage.getItem("step2Guide");
    if (!seen) {
      localStorage.setItem("step2Guide", "true");
      setTimeout(() => setGuideStep(1), 800);
    }
  }, []);

  /* Scroll anchor into view on bot step change */
  useEffect(() => {
    if (guideStep === null) return;
    botRefs[guideStep - 1]?.current?.scrollIntoView({ behavior:"smooth", block:"center" });
  }, [guideStep]);

  const nextBot = useCallback(() => setGuideStep(p => (p !== null && p < TOTAL) ? p + 1 : null), []);
  const skipBot = useCallback(() => setGuideStep(null), []);

  /* ── AUTO-ADVANCE BOT
   * Moves bot to targetStep with 550ms delay.
   * Lock ensures each step is only auto-jumped once.
   */
  const autoAdvanceBot = useCallback((targetStep: number) => {
    if (autoAdvancedRef.current.has(targetStep)) return;
    autoAdvancedRef.current.add(targetStep);
    setTimeout(() => {
      setGuideStep(prev => {
        if (prev === targetStep - 1 || prev === targetStep) return targetStep;
        return prev;
      });
    }, 550);
  }, []);

  /* Step 6 (continue) — NO zIndex */
  const gw = (n: number): React.CSSProperties => {
    if (n === 6) return { position: "relative" };
    return { position: "relative", zIndex: guideStep === n ? 9500 : 1 };
  };

  const handleNext = () => setCurrentIndex(prev => prev + 1);

  /* Option select + auto-advance */
  const handleOptionSelect = (index: number, questionId: number, optionId: number, nextBotStep: number) => {
    selectOption(questionId, optionId);
    if (stepQuestions[index].selected === "") {
      handleNext();
      autoAdvanceBot(nextBotStep);
    }
  };

  const handleSubmit = (e: React.MouseEvent) => {
    e.preventDefault(); e.stopPropagation();
    if (validate2()) nextStep();
  };

  const handleBack = (e: React.MouseEvent) => {
    e.preventDefault(); e.stopPropagation();
    prevStep();
  };

  const customStyles: StylesConfig<SelectOption> = {
    control:           b => ({ ...b, backgroundColor:"transparent", borderColor:"#888888", borderRadius:"50px", minHeight:"38px", boxShadow:"none", color:"#1a202c", cursor:"pointer" }),
    menu:              b => ({ ...b, zIndex:100000 }),
    menuPortal:        b => ({ ...b, zIndex:100000 }),
    valueContainer:    b => ({ ...b, padding:"0 8px" }),
    dropdownIndicator: b => ({ ...b, padding:"8px", color:"#1a202c" }),
    option:            (b, state) => ({ ...b, backgroundColor: state.isSelected ? "#c0001a" : state.isFocused ? "#fff0f0" : "#fff", color: state.isSelected ? "#fff" : "#1a202c", cursor:"pointer" }),
  };

  return (
    <>
      {/* Bot popup — no overlay */}
      {guideStep !== null && guideStep >= 1 && guideStep <= TOTAL && (
        <BotPopup
          anchorRef={botRefs[guideStep - 1]}
          step={guideStep}
          data={BOT_STEPS[guideStep - 1]}
          onSkip={skipBot}
          onNext={guideStep < TOTAL ? nextBot : skipBot}
          nextLabel={guideStep < TOTAL ? "Next →" : "Done ✓"}
        />
      )}

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-primary">
        <div className="container justify-content-center">
          <Link className="navbar-brand" to="/"><img src={logo} alt="" className="img-fluid"/></Link>
        </div>
      </nav>

      {/* Main — same warm background as Step4 */}
      <section className="ob2-section onboarding_main_wraper py-60">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-10 offset-xl-2 offset-lg-1">

              <div className="onboarding_step_top_wraper mb-4">
                <h2 className="mb-1" style={{ fontFamily:"'Inter',sans-serif", fontWeight:800, letterSpacing:"-.02em" }}>
                  Your dating preferences
                </h2>
                <p style={{ color:"#94a3b8", fontSize:13, fontFamily:"'Inter',sans-serif", marginBottom:10 }}>
                  Question 2/6
                </p>
                <div className="ob2-prog-wrap">
                  <div className="ob2-prog-bar done"/>
                  <div className="ob2-prog-bar active"/>
                  <div className="ob2-prog-bar"/>
                  <div className="ob2-prog-bar"/>
                  <div className="ob2-prog-bar"/>
                  <div className="ob2-prog-bar"/>
                </div>
              </div>

              <form className="onboarding_form" onSubmit={e => e.preventDefault()} onKeyDown={e => { if (e.key === "Enter") e.preventDefault(); }}>
                {stepQuestions.length > 0 ? (
                  <>
                    {/* ── Q1 — Looking for — Bot Step 1 anchor ── */}
                    {(currentIndex >= 0 || stepQuestions[0]?.selected !== "") && (
                      <div ref={refQ1} className="form_group" style={gw(1)}>
                        <label className="form-label w-100">{stepQuestions[0].question}</label>
                        <div className="btn-group custom_radio_group" role="group">
                          {stepQuestions[0].questions_options.map((opt: any) => (
                            <React.Fragment key={opt.id}>
                              <input type="radio" defaultChecked={stepQuestions[0].selected === opt.id} id={`opt-${opt.id}`} className="btn-check" name={`opt-${stepQuestions[0].id}`}/>
                              <label
                                className="btn btn-outline-secondary"
                                htmlFor={`opt-${opt.id}`}
                                onClick={() => handleOptionSelect(0, stepQuestions[0].id, opt.id, 2)}
                                aria-pressed={stepQuestions[0].selected === opt.id}
                              >{opt.option}</label>
                            </React.Fragment>
                          ))}
                        </div>
                        {errors[`question_${stepQuestions[0].id}`] && <p className="text-danger text-sm">{errors[`question_${stepQuestions[0].id}`]}</p>}
                      </div>
                    )}
                    <BotSpacer n={1} />

                    {/* ── Q2 — Relationship type — Bot Step 2 anchor ── */}
                    {(currentIndex >= 1 || stepQuestions[1]?.selected !== "") && (
                      <div ref={refQ2} className="form_group slide-in" style={gw(2)}>
                        <label className="form-label w-100">{stepQuestions[1].question}</label>
                        <div className="btn-group custom_radio_group" role="group">
                          {stepQuestions[1].questions_options.map((opt: any) => (
                            <React.Fragment key={opt.id}>
                              <input type="radio" defaultChecked={stepQuestions[1].selected === opt.id} id={`opt-${opt.id}`} className="btn-check" name={`opt-${stepQuestions[1].id}`}/>
                              <label
                                className="btn btn-outline-secondary"
                                htmlFor={`opt-${opt.id}`}
                                onClick={() => handleOptionSelect(1, stepQuestions[1].id, opt.id, 3)}
                                aria-pressed={stepQuestions[1].selected === opt.id}
                              >{opt.option}</label>
                            </React.Fragment>
                          ))}
                        </div>
                        {errors[`question_${stepQuestions[1].id}`] && <p className="text-danger text-sm">{errors[`question_${stepQuestions[1].id}`]}</p>}
                      </div>
                    )}
                    <BotSpacer n={2} />

                    {/* ── Q3 — Distance — Bot Step 3 anchor ── */}
                    {(currentIndex >= 2 || stepQuestions[2]?.selected !== "") && (
                      <div ref={refQ3} className="form_group slide-in" style={gw(3)}>
                        <label className="form-label w-100">{stepQuestions[2].question}</label>
                        <div className="btn-group custom_radio_group" role="group">
                          {stepQuestions[2].questions_options.map((opt: any) => (
                            <React.Fragment key={opt.id}>
                              <input type="radio" defaultChecked={stepQuestions[2].selected === opt.id} id={`opt-${opt.id}`} className="btn-check" name={`opt-${stepQuestions[2].id}`}/>
                              <label
                                className="btn btn-outline-secondary"
                                htmlFor={`opt-${opt.id}`}
                                onClick={() => handleOptionSelect(2, stepQuestions[2].id, opt.id, 4)}
                                aria-pressed={stepQuestions[2].selected === opt.id}
                              >{opt.option}</label>
                            </React.Fragment>
                          ))}
                        </div>
                        {errors[`question_${stepQuestions[2].id}`] && <p className="text-danger text-sm">{errors[`question_${stepQuestions[2].id}`]}</p>}
                      </div>
                    )}
                    <BotSpacer n={3} />

                    {/* ── Age Range — Bot Step 4 anchor ── */}
                    <div
                      ref={refAgeRange}
                      className={`form_group ${currentIndex >= 3 || inputs["looking_max_age"] != null ? "slide-in" : "slide-out"}`}
                      style={gw(4)}
                    >
                      <label className="form-label w-100">What's my ideal age range for a match?</label>
                      <div className="row g-3">
                        <div className="col-sm-4 col-6 col-md-3">
                          <Select<SelectOption>
                            components={{ IndicatorSeparator: () => null }}
                            classNamePrefix="react-select" placeholder="From"
                            value={ageOptions.find(o => o.value === Number(inputs["looking_min_age"])) || null}
                            options={ageOptions} styles={customStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            onChange={sel => handleInputChange("looking_min_age", sel?.value.toString() || "")}
                          />
                          {errors["looking_min_age"] && <p className="text-danger text-sm">{errors["looking_min_age"]}</p>}
                        </div>
                        <div className="col-sm-4 col-6 col-md-3">
                          <Select<SelectOption>
                            components={{ IndicatorSeparator: () => null }}
                            classNamePrefix="react-select" placeholder="To"
                            value={ageOptions.find(o => o.value === Number(inputs["looking_max_age"])) || null}
                            options={ageOptions} styles={customStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            onChange={sel => {
                              handleInputChange("looking_max_age", sel?.value.toString() || "");
                              handleNext();
                              autoAdvanceBot(5);
                            }}
                          />
                          {errors["looking_max_age"] && <p className="text-danger text-sm">{errors["looking_max_age"]}</p>}
                        </div>
                      </div>
                    </div>
                    <BotSpacer n={4} />

                    {/* ── Q4 — Last question — Bot Step 5 anchor ── */}
                    {(currentIndex >= 4 || stepQuestions[3]?.selected !== "") && (
                      <div ref={refQ4} className="form_group slide-in" style={gw(5)}>
                        <label className="form-label w-100">{stepQuestions[3].question}</label>
                        <div className="btn-group custom_radio_group" role="group">
                          {stepQuestions[3].questions_options.map((opt: any) => (
                            <React.Fragment key={opt.id}>
                              <input type="radio" defaultChecked={stepQuestions[3].selected === opt.id} id={`opt-${opt.id}`} className="btn-check" name={`opt-${stepQuestions[3].id}`}/>
                              <label
                                className="btn btn-outline-secondary"
                                htmlFor={`opt-${opt.id}`}
                                onClick={() => {
                                  handleOptionSelect(3, stepQuestions[3].id, opt.id, 6); // → move to Continue step
                                  setButtonHighlight(true);
                                  setTimeout(() => setButtonHighlight(false), 1000);
                                }}
                                aria-pressed={stepQuestions[3].selected === opt.id}
                              >{opt.option}</label>
                            </React.Fragment>
                          ))}
                        </div>
                        {errors[`question_${stepQuestions[3].id}`] && <p className="text-danger text-sm">{errors[`question_${stepQuestions[3].id}`]}</p>}
                      </div>
                    )}
                    <BotSpacer n={5} />
                  </>
                ) : (
                  <p style={{ textAlign:"center", padding:"40px 0", color:"#94a3b8" }}>Loading questions…</p>
                )}

                {/* ── Buttons — Bot Step 6 anchor, NO zIndex ── */}
                <div className="d-flex justify-content-between mt-5">
                  <button type="button" className="btn btn-outline-secondary" onClick={handleBack}>
                    <i className="fa-solid fa-arrow-left me-2"/>Back
                  </button>
                  <div ref={refContinue}>
                    <button
                      type="button"
                      className={`btn btn-primary${buttonHighlight ? " glow-shake" : ""}`}
                      onClick={handleSubmit}
                    >
                      Continue <i className="fa-solid fa-arrow-right ms-2"/>
                    </button>
                  </div>
                </div>
                <BotSpacer n={6} />

              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step2;